import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface State {
    casingCollapse: boolean;
    linerCollapse: boolean;
    tubingCollapse: boolean;
    tubing1Collapse: boolean;
    tubing2Collapse: boolean;
    surfaceVoltageCollapse: boolean;
    surfaceEquipmentCollapse: boolean;
    performanceCurvesCollapse: boolean;
    surfaceConditionsCollapse: boolean;
    iprTypeCollapse: boolean;
    settingDepthCollapse: boolean;
    fluidCollapse: boolean;
    oilPropertyCollapse: boolean;
    gasPropertyCollapse: boolean;
    gasVolumeCollapse: boolean;
    othersCollapse: boolean;
    correlationCollapse: boolean;
    powerConditionsCollapse: boolean;
    gasImpuritiesCollapse: boolean;
    problemsCollapse: boolean;
    othersTabCollapse: boolean;
    notesCollapse: boolean;
    nozzleDiameterCollapse: boolean;
    throatDiameterCollapse: boolean;
    powerFluidTypeCollapse: boolean;
    summaryCollapse: boolean;    
    projectSummaryCollapse: boolean;
    wellInflowCalculationsCollapse: boolean;
    wellIprCalculationsCollapse: boolean;
    tdhCalculationsCollapse: boolean;
    basicWIFCollapse: boolean,
    basicIPRCollapse: boolean,
    basicTDHCollapse: boolean,
    basicPerformanceCurveCollapse: boolean;
}

export const initialState: State = {
    casingCollapse: true,
    linerCollapse: false,
    tubingCollapse: true,
    tubing1Collapse: true,
    tubing2Collapse: true,
    surfaceVoltageCollapse: true,
    surfaceEquipmentCollapse: true,
    performanceCurvesCollapse: true,
    surfaceConditionsCollapse: true,
    iprTypeCollapse: true,
    settingDepthCollapse: true,
    fluidCollapse: true,
    oilPropertyCollapse: true,
    gasPropertyCollapse: true,
    gasVolumeCollapse: true,
    othersCollapse: true,
    correlationCollapse: true,
    powerConditionsCollapse: true,
    gasImpuritiesCollapse: true,
    problemsCollapse: true,
    othersTabCollapse: true,
    notesCollapse: true,
    nozzleDiameterCollapse: true,
    throatDiameterCollapse: true,
    powerFluidTypeCollapse: true,
    summaryCollapse: true,
    projectSummaryCollapse: true,
    wellInflowCalculationsCollapse: true,
    wellIprCalculationsCollapse: false,
    tdhCalculationsCollapse: true,
    basicWIFCollapse: true,
    basicIPRCollapse: true,
    basicTDHCollapse: true,
    basicPerformanceCurveCollapse: true,
};

const CollapseSlice = createSlice({
    name: "collapse",
    initialState,
    reducers: {
        setBasicWIFCollapse: (state, action: PayloadAction<boolean>) => {
            state.basicWIFCollapse = action.payload;
        },
        setBasicIPRCollapse: (state, action: PayloadAction<boolean>) => {
            state.basicIPRCollapse = action.payload;
        },
        setBasicTDHCollapse: (state, action: PayloadAction<boolean>) => {
            state.basicTDHCollapse = action.payload;
        },
        setCasingCollapse: (state, action: PayloadAction<boolean>) => {
            state.casingCollapse = action.payload;
        },
        setLinerCollapse: (state, action: PayloadAction<boolean>) => {
            state.linerCollapse = action.payload;
        },
        setTubingCollapse: (state, action: PayloadAction<boolean>) => {
            state.tubingCollapse = action.payload;
        },
        setTubing1Collapse: (state, action: PayloadAction<boolean>) => {
            state.tubing1Collapse = action.payload;
        },
        setTubing2Collapse: (state, action: PayloadAction<boolean>) => {
            state.tubing2Collapse = action.payload;
        },
        setSurfaceVoltageCollapse: (state, action: PayloadAction<boolean>) => {
            state.surfaceVoltageCollapse = action.payload;
        },
        setSurfaceEquipmentCollapse: (state, action: PayloadAction<boolean>) => {
            state.surfaceEquipmentCollapse = action.payload;
        },
        setPerformanceCurvesCollapse: (state, action: PayloadAction<boolean>) => {
            state.performanceCurvesCollapse = action.payload;
        },
        setSurfaceConditionsCollapse: (state, action: PayloadAction<boolean>) => {
            state.surfaceConditionsCollapse = action.payload;
        },
        setIprTypeCollapse: (state, action: PayloadAction<boolean>) => {
            state.iprTypeCollapse = action.payload;
        },
        setSettingDepthCollapse: (state, action: PayloadAction<boolean>) => {
            state.settingDepthCollapse = action.payload;
        },
        setFluidCollapse: (state, action: PayloadAction<boolean>) => {
            state.fluidCollapse = action.payload;
        },
        setOilPropertyCollapse: (state, action: PayloadAction<boolean>) => {
            state.oilPropertyCollapse = action.payload;
        },
        setGasPropertyCollapse: (state, action: PayloadAction<boolean>) => {
            state.gasPropertyCollapse = action.payload;
        },
        setGasVolumeCollapse: (state, action: PayloadAction<boolean>) => {
            state.gasVolumeCollapse = action.payload;
        },
        setOthersCollapse: (state, action: PayloadAction<boolean>) => {
            state.othersCollapse = action.payload;
        },
        setCorrelationCollapse: (state, action: PayloadAction<boolean>) => {
            state.correlationCollapse = action.payload;
        },
        setPowerConditionsCollapse: (state, action: PayloadAction<boolean>) => {
            state.powerConditionsCollapse = action.payload;
        },
        setGasImpuritiesCollapse: (state, action: PayloadAction<boolean>) => {
            state.gasImpuritiesCollapse = action.payload;
        },
        setProblemsCollapse: (state, action: PayloadAction<boolean>) => {
            state.problemsCollapse = action.payload;
        },
        setOthersTabCollapse: (state, action: PayloadAction<boolean>) => {
            state.othersTabCollapse = action.payload;
        },
        setNotesCollapse: (state, action: PayloadAction<boolean>) => {
            state.notesCollapse = action.payload;
        },
        setNozzleDiameterCollapse: (state, action: PayloadAction<boolean>) => {
            state.nozzleDiameterCollapse = action?.payload;
        },
        setThroatDiameterCollapse: (state, action: PayloadAction<boolean>) => {
            state.throatDiameterCollapse = action?.payload;
        },
        setPowerFluidTypeCollapse: (state, action: PayloadAction<boolean>) => {
            state.powerFluidTypeCollapse = action.payload;
        },
        setSummaryCollapse: (state, action: PayloadAction<boolean>) => {
            state.summaryCollapse = action.payload;
        },
        setProjectSummaryCollapse: (state, action: PayloadAction<boolean>) => {
            state.projectSummaryCollapse = action.payload;
        },
        setWellInflowCalculationsCollapse: (state, action: PayloadAction<boolean>) => {
            state.wellInflowCalculationsCollapse = action.payload;
        },
        setWellIprCalculationsCollapse: (state, action: PayloadAction<boolean>) => {
            state.wellIprCalculationsCollapse = action.payload;
        },
        setTdhCalculationsCollapse: (state, action: PayloadAction<boolean>) => {
            state.tdhCalculationsCollapse = action.payload;
        },
        setBasicPerformanceCurveCollapse: (state, action: PayloadAction<boolean>) => {
            state.basicPerformanceCurveCollapse = action.payload;
        },
    },
});

export const {
    setCasingCollapse,
    setLinerCollapse,
    setTubingCollapse,
    setTubing1Collapse,
    setTubing2Collapse,
    setSurfaceVoltageCollapse,
    setSurfaceEquipmentCollapse,
    setPerformanceCurvesCollapse,
    setSurfaceConditionsCollapse,
    setIprTypeCollapse,
    setSettingDepthCollapse,
    setFluidCollapse,
    setOilPropertyCollapse,
    setGasPropertyCollapse,
    setGasVolumeCollapse,
    setOthersCollapse,
    setCorrelationCollapse,
    setPowerConditionsCollapse,
    setGasImpuritiesCollapse,
    setProblemsCollapse,
    setOthersTabCollapse,
    setNotesCollapse,
    setNozzleDiameterCollapse,
    setThroatDiameterCollapse,
    setPowerFluidTypeCollapse,
    setSummaryCollapse,
    setProjectSummaryCollapse,
    setWellInflowCalculationsCollapse,
    setWellIprCalculationsCollapse,
    setTdhCalculationsCollapse,
    setBasicWIFCollapse,
    setBasicIPRCollapse,
    setBasicTDHCollapse,
    setBasicPerformanceCurveCollapse,
} = CollapseSlice.actions;
export default CollapseSlice.reducer;
